<div class="parameters-container">
  <div *ngIf="internalUser" class="margin-wrap">
    <p class="margin-bottom-thin"><strong>Select a Category</strong></p>
    <mat-radio-group name="ReportTypes" layout="column">
      <mat-radio-button class="margin-right-thin" *ngFor="let type of internalCCCReportTypes" [value]="type.id" [checked]="type.selected" (change)="radioChange($event)">{{type.name}}</mat-radio-button>
    </mat-radio-group>
  </div>
  <div *ngIf="!internalUser" class="margin-wrap">
    <p class="margin-bottom-thin"><strong>Select a Category</strong></p>
    <mat-radio-group name="ReportTypes" layout="column">
      <mat-radio-button class="margin-right-thin" *ngFor="let type of externalCCCReportTypes" [value]="type.id" [checked]="type.selected" (change)="radioChange($event)">{{type.name}}</mat-radio-button>
    </mat-radio-group>
  </div>
  <div *ngIf="selectedReportType === 'psc' && !loadingPscDescriptions">
    <app-mdm-input outsideLabel="Vizient Contract Category"
                   [selectLimit]="1"
                   [minimumLength]="3"
                   [dropDownSelect]="true"
                   [dropDownData]="pscDescriptions"
                   [(chips)]="selectedPscCategories"
                   [singleSelect]="true"
                   [maxChipTextLength]="45"
                   (selectionChanged)="dataUpdate()"
                   id="productSpendCategory"
                   [disabled]="loadingPscDescriptions">
    </app-mdm-input>
  </div>
  <div class="margin-wrap" *ngIf="loadingPscDescriptions">
    <span>PSC Descriptions Loading...</span>
  </div>
  <div *ngIf="selectedReportType === 'unspsc' && !loadingUnspscCodes">
    <app-mdm-input outsideLabel="UNSPSC Category"
                   [selectLimit]="1"
                   [dropDownSelect]="true"
                   [dropDownData]="unspscCodes"
                   [(chips)]="selectedUnspscCodes"
                   [singleSelect]="true"
                   searchPlaceholderText="Search for (3 character minimum)"
                   [minimumFilterLength]="3"
                   [maxChipTextLength]="45"
                   (selectionChanged)="dataUpdate()"
                   id="unspscCategory"
                   [disabled]="loadingUnspscCodes">
    </app-mdm-input>
  </div>
  <div class="margin-wrap" *ngIf="loadingUnspscCodes">
    <span>Unspsc Codes Descriptions Loading...</span>
  </div>
  <div *ngIf="selectedReportType === 'sync' && !loadingSyncGroupDescriptions">
    <app-mdm-input outsideLabel="Code, Group, and Subcategory Description"
                   [selectLimit]="1"
                   [minimumLength]="3"
                   [dropDownSelect]="true"
                   [dropDownData]="syncGroupDescriptions"
                   [(chips)]="selectedSyncGroupDescriptions"
                   [singleSelect]="true"
                   [maxChipTextLength]="45"
                   (selectionChanged)="dataUpdate()"
                   id="syncCategoryDescription"
                   [disabled]="loadingSyncGroupDescriptions">
    </app-mdm-input>
  </div>
  <div class="margin-wrap" *ngIf="loadingSyncGroupDescriptions">
    <span>Code, Group, and Subcategory Descriptions loading...</span>
  </div>
  <div class="margin-wrap">
    <p class="margin-bottom-thin"><strong>Vendor Selection</strong></p>
    <h6 class="text-wrap">*Input Vendors and Output Vendors are required</h6>
    <mat-radio-group name="SortTypes" layout="column">
      <mat-radio-button class="margin-bottom-thin" *ngFor="let type of sortTypes" [value]="type.id" [checked]="type.selected" (change)="sortRadioChange($event)">{{type.name}}</mat-radio-button>
    </mat-radio-group>
  </div>
  <div>
    <div class="margin-wrap">
      <mat-checkbox [checked]="areVendorsMatched()" (click)="matchVendorsClick()">Same Vendor(s) for Input and Output</mat-checkbox>
    </div>
    <div class="margin-wrap" *ngIf="vendorsLoading">
      <span>Vendors Loading...</span>
    </div>
    <div>
      <app-mdm-input outsideLabel="Input Vendor"
                     [dropDownSelect]="true"
                     [dropDownData]="inputVendors"
                     [(chips)]="selectedInputVendors"
                     [disabled]="disableVendorSelection()"
                     [allowSelectAll]="true"
                     [maxChipsToDisplay]="2"
                     id="inputVendors">
      </app-mdm-input>
      <app-mdm-input outsideLabel="Output Vendor"
                     [dropDownSelect]="true"
                     [dropDownData]="outputVendors"
                     [(chips)]="selectedOutputVendors"
                     [disabled]="disableVendorSelection()"
                     [allowSelectAll]="true"
                     [maxChipsToDisplay]="2"
                     id="outputVendors">
      </app-mdm-input>
    </div>
  </div>
  <div class="margin-wrap">
    <p class="margin-bottom-thin"><strong>Include the following sources</strong></p>
    <div>
      <span><mat-checkbox [checked]="isDerivedChecked()" (click)="derivedCheckboxClick()">Derived</mat-checkbox></span>
      &nbsp;&nbsp;&nbsp;
      <span><mat-checkbox [checked]="isAttributeChecked()" (click)="attributionCheckboxClick()">Attribution</mat-checkbox></span>
    </div>
  </div>
  <div class="margin-wrap buttons-right">
    <ng-container *ngIf="!searchInProgress">
      <button mat-button mat-raised-button color="primary" (click)="pullReport()" [disabled]="!pullReportAllowed()">Pull CCC report</button>
    </ng-container>
    <ng-container *ngIf="searchInProgress">
      <button mat-button mat-raised-button color="primary" (click)="cancelSearch()">Cancel</button>
    </ng-container>
    <button class="margin-right-thin" mat-button mat-raised-button color="primary" (click)="clearParameters()">Clear</button>
  </div>
</div>
